import * as React from "react";
import { copyText } from "./helpers";
import Toast from "./Toast";

export default function CopyButton({ text }) {

    const [copiedStatus, setCopiedStatus] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (copiedStatus) {
            copyText(text);
            const to = setTimeout(setCopiedStatus, 1000, false);
            return () => clearTimeout(to);
        }
    }, [copiedStatus, text]);

    return <div className="wrapper"><button onClick={() => setCopiedStatus(true)}>{
        copiedStatus ? <><span className="material-symbols-rounded icon-light">check</span><Toast text={"Copied to clipboard."} intent={"success"} /></> : <span className="material-symbols-rounded icon-light">content_copy</span>
    }</button>
    <style jsx>
        {`
            button {
                display: flex;
                justify-content: center;
            }
            .wrapper {
                height: auto;
                place-items: center;
                display: flex;
            }
            :global(.dark .material-symbols-rounded.icon-light) {
                color: white;
            }
        `}
    </style>
    </div>;

}
